import type { CityConfig } from "../city-template/types";

export const caldwellConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Caldwell",
  state: "Idaho",
  stateAbbr: "ID",
  slug: "caldwell",
  route: "/cities/caldwell",
  title: "Caldwell ID Passport — Expedited & Emergency Service | Fast Passport Center",
  metaDescription: "Expedited and emergency passport services in Caldwell, Idaho — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Caldwell, Nampa, Middleton, Parma, and all Canyon County communities.",
  h1: "Expedited Passport Services in Caldwell, ID",
  heroSubtitle: "College of Idaho study abroad program starting this semester? Canyon County family trip to Mexico booked for winter break? Business travel to Canada for agribusiness meetings? Caldwell residents — from C of I students to Indian Creek Plaza visitors to Simplot and agribusiness professionals — trust us for fast, reliable passport processing. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20scenic%20view%20of%20Caldwell%20Idaho%20downtown%20Indian%20Creek%20Plaza%20with%20historic%20district%20buildings%20and%20fountains%2C%20College%20of%20Idaho%20campus%20visible%20in%20the%20distance%20with%20tree-lined%20streets%2C%20Treasure%20Valley%20agricultural%20landscape%20and%20Owyhee%20Mountains%20backdrop%20at%20golden%20hour%2C%20warm%20sunset%20light%20over%20Canyon%20County%20with%20peaceful%20small-town%20charm&width=1800&height=700&seq=caldwell-hero-2026&orientation=landscape",
  heroImageAlt: "Caldwell Idaho downtown Indian Creek Plaza and College of Idaho at golden hour",
  geoPosition: "43.6629;-116.6874",
  geoPlacename: "Caldwell, Idaho",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Closest regional agency — approximately 800 miles, appointments required",
  },
  nearbyCitiesZips: [
    { name: "Caldwell", zips: "83605, 83606, 83607" },
    { name: "Nampa", zips: "83651, 83686, 83687" },
    { name: "Middleton", zips: "83644" },
    { name: "Parma", zips: "83660" },
    { name: "Homedale", zips: "83628" },
    { name: "Boise", zips: "83701–83799" },
    { name: "Meridian", zips: "83642, 83646" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Canyon County Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Caldwell and western Treasure Valley travelers with immediate departures from Boise Airport." },
    { icon: "ri-flight-takeoff-line", title: "BOI Airport Expertise", desc: "Boise Airport is just 30 minutes away with connections to major hubs serving international routes. We know airline schedules and seasonal travel patterns for Canyon County travelers." },
    { icon: "ri-graduation-cap-line", title: "College of Idaho Student Focus", desc: "C of I students studying abroad for Winter Term or semester programs — we guide first-time and renewal applicants through expedited timelines that match academic calendars." },
    { icon: "ri-home-heart-line", title: "Canyon County Family Specialists", desc: "From first-time passports for Middleton families to renewals for Parma and Homedale retirees heading south for winter — we make the process clear, fast, and stress-free." },
  ],
  internalLinks: [
    { name: "Fast passport services in Nampa, ID", route: "/cities/nampa" },
    { name: "Expedited services in Boise, ID", route: "/cities/boise" },
    { name: "Idaho passport services overview", route: "/states/idaho" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Caldwell via secure registered courier with direct access to State Department processing. Our registered couriers hand-deliver your documents — meaning Caldwell residents get faster results without driving anywhere. Ship from any UPS Store, FedEx Office, or post office in Canyon County.",
  fpcOfficeDistance: "Serving Caldwell, Nampa, Middleton, Parma, Homedale, and all Canyon County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Caldwell and greater Canyon County. From the historic Indian Creek Plaza downtown to the College of Idaho campus corridor, from the Sunnyslope wine region to the agricultural communities of Parma and Homedale — we serve all of western Treasure Valley. Our courier service eliminates the need for any in-person office visit.",
  nearbyCitiesIntro: "We serve Caldwell and all Treasure Valley communities including Nampa, Middleton, Parma, Homedale, Boise, and Meridian. We also serve travelers departing from Boise Airport (BOI) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Caldwell as simple as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Caldwell travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Western Treasure Valley travelers encounter unique passport issues — from C of I Winter Term study abroad deadlines to last-minute agribusiness trade missions. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Caldwell and Canyon County travelers — from C of I students to Middleton families to Parma professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Caldwell, ID? Here are the most common ones we hear from Canyon County travelers.",
  statePageRoute: "/states/idaho",
  statePageName: "Idaho",
  servicesIntro: "Whether you need a renewal before a BOI international connection, an emergency passport for a last-minute business trip, or a first-time passport for your C of I student heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://itd.idaho.gov/dmv/",
  dmvLabel: "Idaho Transportation Department — DMV Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Closest agency is Denver (800 miles)", "Not practical for Treasure Valley travelers"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates", "No need to travel anywhere"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Updates only by physical mail", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "International flight from BOI tomorrow? Family emergency requiring immediate travel? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Caldwell travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Caldwell residents renew fast — no agency visit required for most renewals. Perfect for Canyon County professionals and families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Caldwell residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your travel plans are not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Canyon County family trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Caldwell ID", description: "Urgent passport processing for Caldwell Idaho travelers with immediate departure needs from Boise Airport." },
    { name: "Expedited Passport Renewal Caldwell ID", description: "Fast passport renewal for Caldwell Idaho residents with a previously-issued passport." },
    { name: "First-Time Passport Caldwell ID", description: "New passport application services for Caldwell Idaho residents applying for their first passport." },
    { name: "Child Passport Caldwell ID", description: "Minor passport services for Caldwell Idaho families with children under 16." },
    { name: "Name Change Passport Caldwell ID", description: "Passport name correction after marriage, divorce, or legal name changes for Caldwell residents." },
    { name: "Passport Card Caldwell ID", description: "Passport card services for land and sea crossings from Caldwell Idaho." },
  ],
  testimonials: [
    {
      name: "The Martinez Family",
      location: "Caldwell",
      rating: 5,
      text: "Booked a spring break trip to Puerto Vallarta for the whole family and realized three of us had expired passports. Fast Passport Center processed everything in 7 business days. The checklist was incredibly helpful for our Canyon County crew.",
      service: "Family Passport Renewal",
    },
    {
      name: "Emily H.",
      location: "Caldwell — C of I Student",
      rating: 5,
      text: "Got accepted to C of I's Winter Term program in Spain with only 5 weeks before departure. Never had a passport. They guided me through every step as a first-time applicant and I got it in 6 days.",
      service: "New Passport",
    },
    {
      name: "Bob T.",
      location: "Middleton",
      rating: 5,
      text: "Needed a passport renewal fast for an agribusiness conference in Germany. Fast Passport Center got it done in 4 business days. The document review caught a photo issue I would have missed.",
      service: "Passport Renewal",
    },
    {
      name: "Janet & Ron S.",
      location: "Caldwell",
      rating: 5,
      text: "Retiring and booked a Mediterranean cruise, then realized both our passports were expired. Fast Passport Center processed both renewals in a week and we made our departure date.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "caldwell-1",
      name: "Caldwell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "823 Arthur St",
      city: "Caldwell",
      state: "ID",
      zip: "83605",
      phone: "(208) 459-2129",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Caldwell",
      website: "https://tools.usps.com/find-location.htm?location=1377501",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility in Caldwell. Passport photos available. Appointment recommended — call ahead, especially during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "caldwell-2",
      name: "Canyon County Clerk — Caldwell",
      type: "County Clerk Passport Acceptance",
      address: "111 N 11th Ave",
      city: "Caldwell",
      state: "ID",
      zip: "83605",
      phone: "(208) 454-7556",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Caldwell",
      website: "https://www.canyonco.org/elected-officials/clerk/",
      websiteLabel: "Canyon County Clerk",
      notes: "County clerk passport acceptance services at the Canyon County Courthouse. Serves all Canyon County residents. No photo services on-site — bring your own photos.",
      icon: "ri-government-line",
    },
    {
      id: "caldwell-3",
      name: "Nampa Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 11th Ave S",
      city: "Nampa",
      state: "ID",
      zip: "83651",
      phone: "(208) 466-2741",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Nampa — 8 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1377556",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility in Nampa serving all of Canyon County. Passport photos available. Good backup option if Caldwell appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "caldwell-4",
      name: "Meridian Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 N Main St",
      city: "Meridian",
      state: "ID",
      zip: "83642",
      phone: "(208) 888-3360",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Meridian — 18 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1377541",
      websiteLabel: "USPS Location",
      notes: "Large acceptance facility serving Meridian and eastern Canyon County. Photo services available. Saturday appointments may be available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver agency is 800 miles away, no walk-ins", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 800 miles to Denver or fly there", fpc: "Most Caldwell travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel with proof of departure", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Canyon County Guidance", agency: "Generic — no BOI airport or C of I expertise", fpc: "Full Canyon County/BOI Airport/C of I knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "C of I Winter Term Study Abroad Rush",
      description: "College of Idaho's signature Winter Term sends students abroad every January. Many students get accepted in November with only 6 weeks to get a passport. First-time applicants need both an acceptance facility visit and processing time — starting in late November is cutting it dangerously close.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Sunnyslope Wine Country Tourists Forgetting Documents",
      description: "Caldwell is the gateway to Idaho's Sunnyslope wine region. Wine tourists planning European wine country trips often focus on itineraries and forget to check passport validity until the week before.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Canyon County pharmacies and big-box stores produce photos that fail State Department standards — wrong background color, shadows, head too small. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Canyon County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Western Treasure Valley travelers booking to Europe or Asia for wine tours, agribusiness, or family visits often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or C of I dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Caldwell clients ship from any UPS Store or FedEx Office in Canyon County." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 800 miles to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Caldwell?", a: "We offer Caldwell-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Is there a passport office in Caldwell?", a: "The Caldwell Post Office at 823 Arthur St serves as a passport acceptance facility for first-time applications. The Canyon County Clerk at 111 N 11th Ave also provides acceptance services. For expedited processing beyond the standard timeline, our registered courier service is the fastest option." },
    { q: "Can C of I students apply for passports on campus?", a: "The College of Idaho does not have an on-campus passport acceptance facility. C of I students should use the Caldwell Post Office or Canyon County Clerk for their acceptance clerk visit — both are within walking distance of campus. We provide step-by-step guidance for C of I students applying for Winter Term and study abroad programs." },
    { q: "Where is the closest passport agency to Caldwell?", a: "The Denver Passport Agency is approximately 800 miles away. It requires appointments and serves life-or-death emergencies only. For all other expedited needs, our courier channel is faster and eliminates the need for long-distance travel." },
    { q: "Can you help with passports for flights from Boise Airport?", a: "Yes. Boise Airport (BOI) is just 30 minutes from Caldwell. We regularly assist Canyon County travelers with expedited passports for international connections through BOI to hubs like Seattle, Denver, Salt Lake City, and Phoenix." },
    { q: "What documents do Caldwell applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Caldwell-specific checklist." },
    { q: "Where can I get passport photos in Caldwell?", a: "The Caldwell Post Office, Walgreens on Cleveland Blvd, and Staples in Nampa all offer passport photo services. We recommend confirming photo standards compliance before visiting." },
    { q: "What is the best price for expedited service in Caldwell?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "How do I check my Caldwell passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Caldwell to final return shipping typically matches your chosen speed tier." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Caldwell Residents",
    intro: "Caldwell anchors the western edge of the Treasure Valley metro area and is home to the College of Idaho and major agribusiness operations. Here's what Canyon County travelers need to know about passport timing.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BOI — Boise Airport",
        subtitle: "Primary commercial airport for the Treasure Valley, about 30 minutes from Caldwell",
        description: "Boise Airport connects the Treasure Valley to major U.S. hubs — Seattle, Denver, Salt Lake City, Phoenix, and Minneapolis — where travelers connect to international flights worldwide. Caldwell residents frequently use BOI for international connections. The 30-minute drive is easy, but the convenience sometimes masks the need for passport readiness — especially for last-minute bookings.",
        tip: "BOI connections to international destinations require a valid passport at the first check-in counter. If you are connecting through Seattle to London, your passport must be valid at BOI, not just at SeaTac.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "College of Idaho Winter Term & Study Abroad",
        subtitle: "C of I's signature January programs sending students worldwide",
        description: "The College of Idaho's Winter Term is a cornerstone of the academic calendar, sending roughly 200 students abroad each January to destinations across Europe, Asia, Latin America, and Africa. Many students — especially freshmen — have never had passports. The acceptance-to-departure window is typically November to January, making November the busiest month for C of I student passport applications.",
        tip: "C of I students should begin their passport application process immediately upon Winter Term or study abroad acceptance. First-time applicants need both an acceptance facility visit and processing time, which can take 4–6 weeks during peak season.",
      },
      {
        icon: "ri-plant-line",
        title: "Canyon County Agribusiness Travel",
        subtitle: "J.R. Simplot Company and the Treasure Valley food processing industry",
        description: "Caldwell and Canyon County are major centers for agribusiness — from Simplot's food processing operations to the Sunnyslope wine industry. Agribusiness professionals frequently travel internationally for trade shows, supplier meetings, and industry conferences in Europe, Asia, and Latin America. These trips are often scheduled on 3–6 weeks of notice and require valid passports plus sometimes visas.",
        tip: "Agribusiness professionals should maintain a current passport at all times. International trade missions and conferences frequently come with short notice, and waiting until the last minute creates unnecessary stress.",
      },
    ],
  },
  destinations: {
    title: "Where Caldwell Travelers Go — And Why Passports Get Urgent",
    intro: "Canyon County residents travel abroad for education, business, and family. C of I drives significant academic travel, while the region's agribusiness sector generates regular international business trips.",
    stats: [
      { stat: "40%", label: "of Caldwell expedited requests are education-related — C of I Winter Term and study abroad students" },
      { stat: "4–8 Weeks", label: "average lead time from C of I program acceptance to international departure" },
      { stat: "Oct–Dec", label: "peak season when Winter Term applications, holiday travel, and winter getaways converge" },
      { stat: "6 Days", label: "typical turnaround for Caldwell-area expedited passport processing" },
    ],
    destinations: [
      { name: "Europe", context: "C of I Winter Term programs in Spain, France, Italy, UK; agribusiness trade shows in Germany", urgency: "Winter Term acceptance in November with January departure — just 6–8 weeks", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Central America", context: "C of I service learning trips, Canyon County family spring break vacations", urgency: "Spring break bookings peak January–February with fixed departure dates", icon: "ri-map-pin-2-line" },
      { name: "Asia", context: "Agribusiness trade missions to Japan, South Korea, China for food industry", urgency: "Industry trade shows with fixed dates and complex visa timelines", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "British Columbia wine country tours, Vancouver business trips, Canadian Rockies vacations", urgency: "Summer trips booked 2–4 weeks out, families discover passport issues at packing time", icon: "ri-map-pin-2-line" },
      { name: "Caribbean Cruises", context: "Popular with Canyon County families and retirees, departing Seattle or Florida ports", urgency: "Cruise line documentation deadlines are strict with no flexibility", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Treasure Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Treasure Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Nampa", route: "/cities/nampa" },
      { name: "Boise", route: "/cities/boise" },
    ],
  },
  photoLocations: [
    { name: "Caldwell Post Office", address: "823 Arthur St, Caldwell, ID 83605", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Caldwell", address: "2711 Cleveland Blvd, Caldwell, ID 83605", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/" },
    { name: "Staples — Nampa", address: "16434 N Marketplace Blvd, Nampa, ID 83687", hours: "Mon–Fri 8 AM – 8 PM, Sat 9 AM – 6 PM", website: "https://www.staples.com/" },
    { name: "The UPS Store — Caldwell", address: "2524 S 10th Ave, Caldwell, ID 83605", hours: "Call for hours", website: "https://www.theupsstore.com/" },
  ],
  dmvLocations: [
    {
      name: "Canyon County DMV — Caldwell",
      address: "6107 Graye Ln, Caldwell, ID 83607",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "BOI",
      name: "Boise Airport",
      distance: "About 30 minutes from Caldwell",
      address: "3201 W Airport Way, Boise, ID 83705",
      note: "Primary commercial airport for the Treasure Valley. Major airlines connect through Seattle, Denver, Salt Lake City, Phoenix, and Minneapolis to international destinations worldwide.",
      flightUrl: "https://www.iflyboise.com/",
      flightLabel: "Boise Airport Website",
      featured: true,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from Idaho Vital Records. Online, mail, or in-person options available for Canyon County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Idaho Vital Records. Required for estate and legal matters in Canyon County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Canyon County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.canyonco.org/elected-officials/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Canyon County District Court. Required for name change passport corrections.",
      url: "https://www.canyonco.org/courts/",
    },
  ],
};